import { render, staticRenderFns } from "./MsgElementText.vue?vue&type=template&id=e5925418&scoped=true"
import script from "./MsgElementText.vue?vue&type=script&lang=js"
export * from "./MsgElementText.vue?vue&type=script&lang=js"
import style0 from "./MsgElementText.vue?vue&type=style&index=0&id=e5925418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5925418",
  null
  
)

export default component.exports